<template>
  <a-modal
    :footer="false"
    :open="isOpen"
    :title="`DO YOU WANT TO ${
      status == 'active' ? 'SUSPEND' : 'ACTIVATE'
    } THIS DEPOT?`"
    @cancel="close"
  >
    <div class="flex justify-evenly gap-10 my-10">
      <SubmitButton
        @click="toggleDepotStatus"
        :val="'Yes'"
        :loading="this.loading"
      />
      <SubmitButton
        @click="close"
        class="bg-red-500"
        :val="'No'"
        :loading="false"
      />
    </div>
  </a-modal>
</template>
  
  <script>
//services
import depotService from "@/services/depot-service";

//libraries
import { useToast } from "vue-toastification";

//components
import SubmitButton from "@/components/UI/Inputs/FormSubmitInput.vue";

export default {
  name: "SuspendDepotModal",
  props: ["isOpen", "close", "status", "depotId", "getDepotDetails"],
  components: {
    SubmitButton,
  },
  data() {
    return {
      loading: false,
      toast: useToast(),
    };
  },
  methods: {
    //requests

    async toggleDepotStatus() {
      this.loading = true;
      let status = this.status === "active" ? "suspended" : "active";
      const data = {
        depotId: this.depotId,
        status,
      };

      try {
        const result = await depotService.suspendDepot(data);
        this.getDepotDetails();
        this.toast.success(result.message);

        this.loading = false;

        this.close();
      } catch (err) {
        this.loading = false;
      }
    },
  },
};
</script>
  
  <style></style>
  